import { render, staticRenderFns } from "./zeroActDetail.vue?vue&type=template&id=4d61233e&scoped=true&"
import script from "./zeroActDetail.vue?vue&type=script&lang=js&"
export * from "./zeroActDetail.vue?vue&type=script&lang=js&"
import style0 from "./zeroActDetail.vue?vue&type=style&index=0&id=4d61233e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d61233e",
  null
  
)

export default component.exports